import { matchPath } from 'react-router-dom';
import { routes } from 'route-data/routes';

export const findRouteMatch = pathname => {
  for (let index = 0; index < routes.length; index += 1) {
    const { analyticsName, getAnalyticsName, pageType, fetch, clientFetch, path, preload } =
      routes[index];

    const match = matchPath(
      {
        path,
      },
      pathname,
    );

    if (match) {
      return {
        analyticsName: getAnalyticsName ? getAnalyticsName(pathname) : analyticsName,
        pageType,
        fetch,
        clientFetch,
        index,
        match,
        preload,
      };
    }
  }

  return undefined;
};
